const initialState = {
	letterData: null,
	letterId: null,
	caret: null,
	tempCaret: { start: 0, end: 0, text: "" },
	popoverPosition: {x: 0, y: 0},
	popoverDisablePointerEvents: false,
	currentChangesHistory: null,
	// infoText: '',
	eventObject: null,
	isMobile: false,

	popoverMode: 0,
	// 0 - select text
	// 1 - edit selection - disable select
	// 2 - change clicked - disable select 

	addToExistingMode: false,
	// user clicks handler on text -> changes history is shown -> user clicks add new change (to current history)

	editMode: false,
	// editing existing change

	requestPending: false,
	// request is pending - show spinner

	editLetterMetadata: false,
	// user is owner of letter or admin and clicked "edit metadata" pencil next to title in LetterHeader - show editMetadata popup

	currentSelectedChangeId: null,

	autoChangesIsLoading: false,
};

export default initialState;